export enum CollectionItemType {
  Folder,
  Project,
  Datasource
}
